export default __webpack_public_path__ + "static/media/Clocks.a4d81390.png";